import { Title } from '@solidjs/meta'
import type { Component } from 'solid-js'
import Card from '~/components/Card'
import Container from '~/components/Container'
import GoBack from '~/components/GoBack'
import Icon from '~/components/Icon'

const GoBackPage: Component = () => {
  return (
    <>
      <Title>GoBack - Florez Jaramillo Solutions</Title>

      <Container class="py-8">
        <div class="mb-10 mt-6 text-balance">
          <h1 class="text-4xl font-bold text-foreground mb-4">GoBack</h1>
          <p class="text-foreground-subtle text-xl max-w-3xl leading-relaxed">
            Navegación de retroceso con intención. GoBack regresa a la página anterior del historial y, si no existe, navega a una ruta de respaldo — ideal para vistas de detalle y flujos anidados.
          </p>
        </div>

        <div class="space-y-12">
          {/* Uso básico */}
          <Card>
            <Card.Header
              title="Uso básico"
              subtitle="Botón de retroceso con etiqueta por defecto y variantes personalizadas."
              icon={<Icon icon="material-symbols-light:arrow-back" class="text-primary" size={24} />}
            />
            <Card.Body>
              <div class="flex flex-col gap-6 p-8 bg-surface-muted rounded-2xl border border-border border-dashed">
                <div class="flex items-center gap-3">
                  <span class="text-xs font-semibold text-foreground-subtle w-32">Por defecto</span>
                  <GoBack />
                </div>
                <div class="flex items-center gap-3">
                  <span class="text-xs font-semibold text-foreground-subtle w-32">Etiqueta custom</span>
                  <GoBack label="Regresar al inicio" fallbackPath="/" />
                </div>
                <div class="flex items-center gap-3">
                  <span class="text-xs font-semibold text-foreground-subtle w-32">onClick propio</span>
                  <GoBack label="Cancelar edición" onClick={() => alert('Acción de retroceso personalizada')} />
                </div>
              </div>
            </Card.Body>
          </Card>

          {/* En contexto */}
          <Card>
            <Card.Header
              title="En contexto"
              subtitle="Colocado sobre el encabezado de una vista de detalle."
              icon={<Icon icon="material-symbols-light:description-outline" class="text-info" size={24} />}
            />
            <Card.Body>
              <div class="p-6 bg-surface-muted rounded-2xl border border-border">
                <GoBack label="Volver a la lista" fallbackPath="/componentes" class="mb-5" />
                <h3 class="text-2xl font-bold text-foreground">Pedido #60110</h3>
                <p class="text-foreground-subtle mt-1">Detalle del pedido del cliente Soren Durham — creado el 09 jun 2026.</p>
              </div>
            </Card.Body>
          </Card>

          {/* API Reference */}
          <Card>
            <Card.Header title="API Reference" subtitle="Propiedades del componente GoBack." icon={<Icon icon="material-symbols-light:code" class="text-foreground-subtle" size={24} />} />
            <Card.Body>
              <div class="overflow-x-auto rounded-xl border border-border">
                <table class="w-full text-sm text-left">
                  <thead class="text-xs uppercase bg-surface-muted text-foreground-subtle">
                    <tr>
                      <th class="px-6 py-4 border-b border-border">Propiedad</th>
                      <th class="px-6 py-4 border-b border-border">Tipo</th>
                      <th class="px-6 py-4 border-b border-border">Default</th>
                      <th class="px-6 py-4 border-b border-border">Descripción</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-border">
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold text-primary">label</td>
                      <td class="px-6 py-4 italic text-xs">string</td>
                      <td class="px-6 py-4 font-mono">'Volver'</td>
                      <td class="px-6 py-4 italic">Texto del botón.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold">fallbackPath</td>
                      <td class="px-6 py-4 italic text-xs">string</td>
                      <td class="px-6 py-4 font-mono">-</td>
                      <td class="px-6 py-4">Ruta a la que navegar si no hay historial previo.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold">onClick</td>
                      <td class="px-6 py-4 italic text-xs">() =&gt; void</td>
                      <td class="px-6 py-4 font-mono">-</td>
                      <td class="px-6 py-4 italic">Sobrescribe el comportamiento de retroceso.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold">class</td>
                      <td class="px-6 py-4 italic text-xs">string</td>
                      <td class="px-6 py-4 font-mono">-</td>
                      <td class="px-6 py-4">Clases adicionales para el contenedor.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </>
  )
}

export default GoBackPage
